export enum ActionRef {
  EVALUATE = 'evaluate',
  LOAD = 'load',
  CREATE = 'create',
  UPDATE = 'update',
  DELETE = 'delete',
  SEARCH = 'search',
  LOGIN = 'login',
  REGISTER = 'register',
  CHANGE_PASSWORD = 'changePassword',
  FORGOT_PASSWORD = 'forgotPassword',
  RESET_PASSWORD = 'resetPassword',
  DEFAULT = 'default',
}
